<template>
	<div class="home-container">
		<!-- 顶部导航栏 -->
		<header class="navbar">
			<div class="logo" @click="goto('/')">
				<img src="../assets/logo.png" alt="logo" />
				<span>淞淞零工</span>
			</div>
			<nav class="nav-links">
				<span v-for="(item, index) in navs" :key="index" class="nav-item"
					:class="{ active: current === item.path }" @click="goto(item.path)">
					{{ item.label }}
				</span>
			</nav>
		</header>

		<!-- 背景层 -->
		<div class="background-gradient"></div>

		<!-- 内容层 -->
		<div class="content-wrapper" v-if="current == '/'">
			<h1 class="title">找人干活</h1>
			<p class="subtitle">一站式零工匹配平台 · 快速帮您找到靠谱工人</p>

			<div class="card">
				<p class="card-text">输入需求，马上帮您匹配合适的工人。</p>
				<button class="main-btn" @click="goto('/work')">查询附近工人</button>
			</div>

			<!-- 	<footer class="footer">
				<p>© 2025 淞淞零工 | 专业连接工人与雇主</p>
			</footer> -->
			<footer class="footer">
				<div>
					<a target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15050202000333"
						style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px; color: #efefef;">
						<p style="display: flex;align-items: center;color: #f1f1f1;"><img src="../assets/beian.png"
								style="width: 20px;height: 20px;" /> 蒙公网安备 15050202000333号</p>
					</a>
				</div>
				<div>
					<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
						style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px; color: #efefef;">
						<p>蒙ICP备19003815号-3</p>
					</a>
				</div>


			</footer>
		</div>
		<div class="content-wrapper" v-else>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: "HomeIndex",
		data() {
			return {
				current: "/",
				navs: [{
						label: "首页",
						path: "/",
					},
					{
						label: "发布零工需求",
						path: "/release",
					},
					{
						label: "查询附近工人",
						path: "/work",
					},
					{
						label: "工人注册",
						path: "/reg",
					},
					{
						label: "关于淞淞",
						path: "/me",
					},
				],
			};
		},
		methods: {
			goto(path) {
				this.current = path;
				this.$router.push(path);
			},
		},
	};
</script>

<style scoped>
	/* 整体布局 */
	.home-container {
		width: 100%;
		height: 100vh;
		overflow-x: hidden;
		position: relative;
		display: flex;
		flex-direction: column;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		color: #fff;
	}

	/* 顶部导航 */
	.navbar {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;
		width: 100%;
		height: 10vh;
		background: rgba(255, 255, 255, 0.15);
		backdrop-filter: blur(10px);
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 40px;
		box-sizing: border-box;
		border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	}

	.logo {
		display: flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
	}

	.logo img {
		width: 60px;
		height: 60px;
	}

	.logo span {
		font-size: 30px;
		font-weight: 600;
		color: #fff;
		letter-spacing: 1px;
	}

	.nav-links {
		display: flex;
		gap: 30px;
	}

	.nav-item {
		font-size: 16px;
		color: #e0e7ff;
		cursor: pointer;
		position: relative;
		transition: all 0.3s;
	}

	.nav-item:hover {
		color: #fff;
	}

	.nav-item.active::after {
		content: "";
		position: absolute;
		bottom: -4px;
		left: 0;
		width: 100%;
		height: 2px;
		background: #fff;
		border-radius: 2px;
	}

	/* 背景渐变 */
	.background-gradient {
		position: absolute;
		width: 100%;
		height: 100%;
		background: linear-gradient(135deg, #2563eb, #7c3aed);
		z-index: 0;
		animation: bgMove 10s infinite alternate ease-in-out;
	}

	@keyframes bgMove {
		0% {
			background-position: left;
		}

		100% {
			background-position: right;
		}
	}

	/* 内容主体 */
	.content-wrapper {
		position: absolute;
		top: 10vh;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 2;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		/* 	padding-top: 160px;
		padding-bottom: 60px; */
	}

	/* 主标题 */
	.title {
		font-size: 64px;
		font-weight: 700;
		margin-bottom: 10px;
		letter-spacing: 2px;
	}

	/* 副标题 */
	.subtitle {
		font-size: 22px;
		color: #e0e7ff;
		margin-bottom: 60px;
	}

	/* 卡片容器 */
	.card {
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(20px);
		border-radius: 16px;
		padding: 40px;
		width: 90%;
		max-width: 500px;
		margin: 0 auto 80px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
		animation: fadeIn 1.2s ease;
	}

	/* 卡片文字 */
	.card-text {
		font-size: 20px;
		margin-bottom: 30px;
		color: #f3f4f6;
	}

	/* 主按钮 */
	.main-btn {
		background: linear-gradient(90deg, #3b82f6, #2563eb);
		border: none;
		padding: 16px 40px;
		font-size: 20px;
		border-radius: 50px;
		color: white;
		cursor: pointer;
		transition: all 0.3s;
		font-weight: 600;
		box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
	}

	.main-btn:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 20px rgba(37, 99, 235, 0.5);
	}

	/* 底部 */
	.footer {
		color: #cbd5e1;
		font-size: 14px;
		margin-top: 20px;
		opacity: 0.8;
	}

	/* 动画 */
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* 响应式 */
	@media screen and (max-width: 768px) {
		.navbar {
			padding: 0 20px;
		}

		.title {
			font-size: 42px;
		}

		.subtitle {
			font-size: 18px;
		}

		.card {
			padding: 30px;
		}

		.main-btn {
			font-size: 18px;
			padding: 14px 30px;
		}
	}
</style>